import { formatCapXml } from '../utils/formatCapXml.utils';
import styles from './CapXmlViewer.module.css';

// Keep comments and CDATA whole so tag-like content inside them remains data.
const XML_MARKUP =
  /(<!--[\s\S]*?-->|<!\[CDATA\[[\s\S]*?\]\]>|<\?[\s\S]*?\?>|<\/?[\w:.-]+(?:[^<>"']|"[^"]*"|'[^']*')*>)/g;

const renderMarkup = (text, index) => {
  if (text.startsWith('<!--')) {
    return (
      <span className={`fst-italic ${styles.comment}`} key={index}>
        {text}
      </span>
    );
  }

  if (text.startsWith('<![CDATA[')) {
    return (
      <span key={index}>
        <span className={styles.declaration}>{'<![CDATA['}</span>
        {text.slice(9, -3)}
        <span className={styles.declaration}>{']]>'}</span>
      </span>
    );
  }

  const tag = text.match(/^(<[/?]?)([^\s/>?]+)([\s\S]*?)(\??\/?>)$/);
  if (!tag) return text;

  const [, opening, name, attributes, closing] = tag;

  return (
    <span key={index}>
      <span className={styles.punctuation}>{opening}</span>
      <span className={`fw-bold ${opening === '<?' ? styles.declaration : styles.tag}`}>
        {name}
      </span>
      {attributes.match(/"[^"]*"|'[^']*'|[^\s=]+|[\s=]+/g)?.map((part, partIndex) => {
        const className = /^["']/.test(part)
          ? styles['attribute-value']
          : /^[\s=]+$/.test(part)
            ? styles.punctuation
            : styles['attribute-name'];

        return (
          <span className={className} key={partIndex}>
            {part}
          </span>
        );
      })}
      <span className={styles.punctuation}>{closing}</span>
    </span>
  );
};

const CapXmlViewer = ({ xml }) => {
  const formattedXml = formatCapXml(xml);

  return (
    <pre
      className={`small mb-0 p-2 border rounded customScrollbar-Y ${styles.viewer}`}
      aria-label="CAP XML"
      tabIndex={0}
    >
      <code>
        {formattedXml
          ? formattedXml
              .split(XML_MARKUP)
              .map((text, index) => (index % 2 === 1 ? renderMarkup(text, index) : text))
          : 'No CAP XML is available for this FEMA message.'}
      </code>
    </pre>
  );
};

export default CapXmlViewer;
